import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../redux/authSlice";
import { toast } from "sonner";
import validateLoginInput from "../../utils/validateLoginInput";
import ButtonComponent from "../Button";
import loading from "../../assets/svg/loading.svg";
import logo from "/images/junfel-logo.svg";
import { ROUTES } from "../../router/appRoutes";
import { X } from "lucide-react";
import "../../styles/authForm.css";

const Login = () => {
	const [userData, setUserData] = useState({ email: "", password: "" });
	const [isLoading, setIsLoading] = useState(false);
	const [validationErrors, setValidationErrors] = useState({});
	const { error } = useSelector((state) => state.auth);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const year = new Date().getFullYear();

	const handleLogin = async (e) => {
		e.preventDefault();
		// const { email, password } = userData;
		setValidationErrors({}); // Clear previous errors
		const errors = validateLoginInput(userData);

		// Stop submission if there are validation errors
		if (Object.keys(errors).length > 0) {
			setValidationErrors(errors);
			return;
		}
		setIsLoading(true);

		try {
			const resultAction = await dispatch(login(userData));
			// console.log("RESULT:", resultAction);

			if (login.fulfilled.match(resultAction)) {
				navigate(ROUTES.DASHBOARD);
			}

			// Extract error message from Redux payload
			if (!resultAction.ok && resultAction.payload === undefined) {
				const errorMessage =
					resultAction.payload?.error ||
					"Server Error... Please try again later!";
				toast(errorMessage);
			}
		} catch (error) {
			console.error("Login error:", error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<section id="login">
			<form
				onSubmit={handleLogin}
				className="form_container auth_login"
			>
				<div className="auth-header">
					<img
						src={logo}
						alt="Junfel logo"
						className="auth-logo"
						width={72}
						height={24}
					/>
					<X
						onClick={() => navigate(ROUTES.HOME)}
						className="close-icon"
					/>
				</div>

				{error && (
					<p className="error_message_wrapper">
						{error.error} Please try again!
					</p>
				)}

				{/* <h4 className="auth-subtitle">Login to Junfel</h4> */}
				<p className="auth_message">
					Welcome back! Please sign in to continue
				</p>
				<div className="input_container">
					<label>Email address</label>
					<input
						name="email"
						type="email"
						// placeholder="sample@mail.com"
						value={userData.email}
						onChange={(e) =>
							setUserData({ ...userData, email: e.target.value })
						}
						autoComplete="on"
						className={
							validationErrors.email
								? "input_area input_area_error"
								: "input_area"
						}
					/>
					{validationErrors.email && (
						<p className="error_message">{validationErrors.email}</p>
					)}
				</div>
				<div className="input_container">
					<label> Password </label>
					<input
						name="password"
						type="password"
						// placeholder="Enter password"
						value={userData.password}
						onChange={(e) =>
							setUserData({ ...userData, password: e.target.value })
						}
						autoComplete="new-password"
						className={
							validationErrors.password
								? "input_area input_area_error"
								: "input_area"
						}
					/>
					{validationErrors.password && (
						<p className="error_message">{validationErrors.password}</p>
					)}
				</div>
				{isLoading ? (
					<button
						type="submit"
						className="btn_primary"
					>
						<img
							src={loading}
							width={16}
							height={16}
							style={{ marginRight: "15px" }}
						/>
						Loggin in...
					</button>
				) : (
					<ButtonComponent
						type="submit"
						name="Login"
						className="btn_primary"
					/>
				)}
			</form>

			<p className="login_message">
				&copy; {year} | Junfel Velasco
			</p>
		</section>
	);
};

export default Login;
